import I18n from '@/plugins/vue-i18n'
import Vue from 'vue'
import { config } from '@/plugins/env.config'
import store from '@/store'

export const sponsorsWithEnableSpecificTranslations = ['mx-mutuus'];

export const getLocales = () => {
  const defaultLocale = { nameKey: `locales.${config.locale}`, locale: config.locale };

  const predefinedLocales = [
    { nameKey: 'locales.en', locale: 'en' },
    { nameKey: 'locales.pt', locale: 'pt' }
  ];
  
  const userLocale = store.state.auth.tokenExtensions.locale;

  const customLocale = userLocale ? {
    nameKey: `locales.${config.locale}`,
    locale: userLocale.replace(/_/g, "-")
  } : null;

  const locales = [...predefinedLocales];
  if (customLocale && I18n.availableLocales.includes(customLocale.locale)) {
    locales.unshift(customLocale);
  } else {
    locales.push(defaultLocale);
  }

  return locales;
};

export const getLocale = (locale) => {
  const defaultLocale = config.locale;
  
  if(!locale) {
    return defaultLocale
  }
  
  if (locale.length == 2) {
    return I18n.availableLocales.includes(locale) ? locale : defaultLocale;
  }

  if (locale.length > 2) {
    const parsedLocale = locale.replace(/_/g, "-");
    
    return I18n.availableLocales.includes(parsedLocale) ? parsedLocale : defaultLocale;
  }

  return defaultLocale;
}

Vue.prototype.$t = function (key, ...args) {
  const tokenExtensions = this.$store.state.auth.tokenExtensions || {};
  const sponsorSlug = tokenExtensions.sponsorSlug;
  const isEnabledSponsorTranslations = tokenExtensions.sponsorTranslations === 'true';

  if (sponsorsWithEnableSpecificTranslations.includes(sponsorSlug) && isEnabledSponsorTranslations) {
    const clientKey = `${sponsorSlug}.${key}`;

    if (this.$i18n.te(clientKey)) {
      return this.$i18n.t(clientKey, ...args);
    }
  }

  return this.$i18n.t(key, ...args);
};
